import { render } from "./Box.vue?vue&type=template&id=4f764b46"
const script = {}

import "./Box.vue?vue&type=style&index=0&id=4f764b46&lang=css"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__